import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import InputLocationLegacy from './InputLocationLegacy';
import InputLocationNew from './InputLocationNew';
import { type InputLocationProps, type InputLocationRef } from './types';

const InputLocationWrapper = ({
  componentRef,
  ...props
}: InputLocationProps & {
  componentRef?: React.RefObject<InputLocationRef>;
}) => {
  const { flagEvGeoboxSearch } = useFeatureFlag();

  if (flagEvGeoboxSearch) {
    return <InputLocationNew {...props} componentRef={componentRef} />;
  }

  return <InputLocationLegacy {...props} ref={componentRef} />;
};

export default InputLocationWrapper;
